module.exports = __webpack_public_path__ + "static/img/284_TO8_2431_og.473108f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/284_TO8_2431_og.jpg
// module id = 8Uc0
// module chunks = 0